import React, { createContext } from 'react';
import { usePrivileges } from '../../hooks/usePrivileges';

const PrivilegesContext = createContext({});

export const PrivilegesProvider = ({ children }) => {
    const { contributor, admin } = usePrivileges();

    return (
        <PrivilegesContext.Provider value={{ contributor, admin }}>
            {children}
        </PrivilegesContext.Provider>
    );
}

export default PrivilegesContext;